import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, catchError, map, throwError} from 'rxjs';
import {GrauParentescoVM} from 'src/app/api/model/grau-parentesco/grau-parentesco';
import {AppConfigurationService} from '../../services/base/appConfiguration.service';

@Injectable({
  providedIn: 'root',
})
export class ListaAuxiliaresService {
  constructor(
    private httpClient: HttpClient,
    private appConfigurationService: AppConfigurationService,
  ) {}

  listaProfissao(): Observable<any> {
    return this.httpClient.get<any>(`${this.appConfigurationService.apiBaseUrl}/AllLists/ListProfessions`).pipe(
      map(response => {
        return response;
      }),
      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }
  listaCarencias(): Observable<any> {
    return this.httpClient.get<any>(`${this.appConfigurationService.apiBaseUrl}/AllLists/ListNeediness`).pipe(
      map(response => {
        return response;
      }),
      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }
  preferenciaContato(): Observable<any> {
    return this.httpClient.get<any>(`${this.appConfigurationService.apiBaseUrl}/AllLists/ListContactPreferences`).pipe(
      map(response => {
        return response;
      }),
      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }

  listaBancos(): Observable<any> {
    return this.httpClient.get<any>(`${this.appConfigurationService.apiBaseUrl}/AllLists/ListBanks`).pipe(
      map(response => {
        return response;
      }),
      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }

  LitaEstadosCivil(): Observable<any> {
    return this.httpClient.get<any>(`${this.appConfigurationService.apiBaseUrl}/AllLists/ListCivilStatus`).pipe(
      map(response => {
        return response;
      }),
      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }

  ListaOrgaoEmissor(): Observable<any> {
    return this.httpClient.get<any>(`${this.appConfigurationService.apiBaseUrl}/Beneficiary/GetEnums`).pipe(
      map(response => {
        return response;
      }),
      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }

  ListarGrauParentesco(): Observable<GrauParentescoVM[]> {
    return this.httpClient
      .get<GrauParentescoVM[]>(`${this.appConfigurationService.apiBaseUrl}/AllLists/ListRelationships`)
      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }

  listaProfissaoComponente(): Observable<any> {
    return this.httpClient
      .get<any>(`${this.appConfigurationService.apiBaseUrl}/Company/ListProfessionsWithoutACompany`)
      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }

  listaHospitais_E_Laboratorios(page?: any, itemsPerPage?: any): Observable<any> {
    return this.httpClient
      .get<any>(`${this.appConfigurationService.apiBaseUrl}/AllLists/ListHospitalsAndLaboratories`)
      .pipe(
        map(response => response),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }

  listaDeOperadoras(page?: any, itemsPerPage?: any): Observable<any> {
    return this.httpClient.get<any>(`${this.appConfigurationService.apiBaseUrl}/AllLists/ListOperators`).pipe(
      map(response => response),
      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }

  ListaProdutosProposta(): Observable<any> {
    return this.httpClient.get<any>(`${this.appConfigurationService.apiBaseUrl}/AllLists/ListProductsProposal`).pipe(
      map(response => response),
      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }

  listaGeneros(): Observable<any> {
    return this.httpClient.get<any>(`${this.appConfigurationService.apiBaseUrl}/AllLists/ListGenders`).pipe(
      map(response => response),
      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }

  listarBancos(): Observable<any> {
    return this.httpClient.get<any>(`${this.appConfigurationService.apiBaseUrl}/AllLists/ListBanks`).pipe(
      map(response => {
        return response;
      }),
      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }

  listaProfissaoPorEntidadeEOperadora(idEntidade: string, operadoraId: any): Observable<any> {
    return this.httpClient
      .get<any>(
        `${this.appConfigurationService.apiBaseUrl}/AllLists/ListProfessionsWithEntityAndOperator?branchCompanyId=${idEntidade}&operatorId=${operadoraId}`,
      )
      .pipe(
        map(response => response),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }
  listarTiposDocumento(): Observable<any> {
    return this.httpClient.get<any>(`${this.appConfigurationService.apiBaseUrl}/AllLists/ListDocumentsTypes`).pipe(
      map(response => response),
      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }
  listarEnumBeneficiarioCRM(): Observable<any> {
    return this.httpClient
      .get<any>(`${this.appConfigurationService.apiBaseUrl}/AllLists/ListBeneficiaryChangeEnums`)
      .pipe(
        map(response => response),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }
  listaEnumCRMTicket(): Observable<any> {
    return this.httpClient.get<any>(`${this.appConfigurationService.apiBaseUrl}/AllLists/ListCrmTicketEnums`).pipe(
      map(response => response),
      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }
}
